<div class="loading">
    <fui-loading [type]="'spinner'"></fui-loading>
</div>
